module.exports = __webpack_public_path__ + "img/star.c31a0962.svg";